
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "88d2c181e9fef8b8d7eddeafa8323264f6c87158",
  "nuxt": {
    "buildId": "02f683c0-79d7-4866-bf9f-d7df4dbc30cb"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
